<div class="overlay">
  <div class="signature-container">
    <canvas #canvas></canvas>

    <div class="button-row">
      <ion-button color="medium" (click)="cancel()">Cancel</ion-button>
      <ion-button color="primary" (click)="submit()">Submit</ion-button>
    </div>

    <ion-button fill="clear" color="dark" (click)="clear()" class="clear-button">
      Clear
    </ion-button>
  </div>
</div>
